module.exports = __webpack_public_path__ + "img/Lisensi-KasPro.8ae06967.webp";